<template>
  <v-row>
    <v-col cols="12">
      <Header />
    </v-col>
    <v-col cols="12">
      <Products v-if="id == 'products'" />
      <FourOverProducts v-if="id == '4over'" />
      <LookupTable
        v-if="id == 'stocks'"
        type="stocks"
        title="Stocks"
      />
      <LookupTable
        v-if="id == 'finishes'"
        type="finishes"
        title="Finishes"
      />
      <LookupTable
        v-if="id == 'materials'"
        type="materials"
        title="Materials"
      />
      <CategoryMaterials v-if="id == 'categorymaterials'" />
      <Options v-if="id == 'options'" />
      <LookupTable
        v-if="id == 'optiongroups'"
        type="option_groups"
        title="Option Groups"
      />
      <LookupTable
        v-if="id == 'turnaroundtypes'"
        type="turnaround_types"
        title="Turnaround Types"
      />
    </v-col>
  </v-row>
</template>

<script>
import Header from '@/components/print/Header';
import Products from '@/components/print/Products';
import FourOverProducts from '@/components/print/fourover/List';
import LookupTable from '@/components/print/LookupTable';
import CategoryMaterials from '@/components/print/CategoryMaterials';
import Options from '@/components/print/Options';
export default {
  name: 'PrintDetail',
  components: {
    Header,
    Products,
    FourOverProducts,
    LookupTable,
    CategoryMaterials,
    Options
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {}
};
</script>
